<template>
    <div class="form-agreement">
        <div
            v-for="agreement in agreementInputs"
            :key="agreement.id"
            class="form-agreement__item"
        >
            <div class="form-agreement__row">
                <input
                    class="form-agreement__checkbox"
                    type="checkbox"
                    :value="agreement.id"
                    :id="'agreement-' + agreement.id"
                    @change="updateValue(agreement.id, $event.target.checked)"
                >
                <label
                    class="form-agreement__label"
                    :for="'agreement-' + agreement.id"
                >
                    <span v-if="agreement.required" class="form-agreement__required">*</span>
                    <span class="form-agreement__html" v-html="agreement.content"></span>
                </label>
            </div>
            <ul class="form-agreement__error" v-if="hasError(agreement.id)">
                <li>Prosimy zaznaczyć wymaganą zgodę</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['name', 'errorMessages', 'agreementInputs'],

    methods: {
        updateValue(id, checked) {
            if (!this.value || Array.isArray(this.value) || typeof this.value !== 'object') {
                this.value = {};
            }

            if (checked) {
                this.$set(this.value, id, 1);
            } else {
                this.$delete(this.value, id);
            }

            this.$emit('input', this.value);

            var key = 'agreements.' + id;
            if (this.errorMessages !== null && key in this.errorMessages) {
                this.errorMessages[key] = null;
            }
        },
        hasError(id) {
            var key = 'agreements.' + id;
            if (this.errorMessages !== null && key in this.errorMessages) {
                return true;
            }

            return false;
        },
    },
    data() {
        return {
            value: {},
        };
    },
    watch: {
        errorMessages: function () {
            this.$forceUpdate();
        },
    },
};
</script>
